import { service } from '../../../../helpers/http'

//Retorna a lista com as categorias de grupos
export const ActionGetGroupCategories = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroupCategory',
        action: 'getCategories',
        payload: payload
    })
    
}

//Cadastra uma nova categoria de grupo
export const ActionPostGroupCategories = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroupCategory',
        action: 'postCategories',
        payload: payload
    })
    
}

//Atualiza uma categoria de grupo
export const ActionPutGroupCategories = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroupCategory',
        action: 'putCategories',
        payload: payload
    })
    
}

//Deleta uma categoria de grupo
export const ActionDeleteGroupCategories = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroupCategory',
        action: 'deleteCategories',
        payload: payload
    })
    
}